import { useEffect, useRef } from "react";
import { HighlightColours } from "../../models/HighlightColors";
import { HighlightObjectModified } from "../../models/HighlightObject";
import { HighlightObjectFactory } from "../../models/HighlightObjectFactory";
import { LocationMatcher } from "../../models/matchers/LocationMatcher";
import { useHighlightDispatch } from "../highlightProvider/HighlightProvider";

export { useLocationHighlight };

function useLocationHighlight(
  index: number,
  matcher: LocationMatcher,
  highlightKey: string,
  showHighlights: boolean,
  coordinatesModified: (newCoordinates: HighlightObjectModified) => void,
) {
  const highlightDispatch = useHighlightDispatch();
  const locationHighlightKey = `${highlightKey}-LOC`;

  const coordinatesModifiedRef = useRef(coordinatesModified);
  coordinatesModifiedRef.current = coordinatesModified;

  function dispatchHighlight(
    type: "add" | "remove",
    highlightKey: string,
    color: string,
    section: any,
    modifiedCallback: (newCoordinates: HighlightObjectModified) => void,
  ) {
    highlightDispatch({
      type,
      highlight: HighlightObjectFactory.createSectionHighlight(
        highlightKey,
        color,
        section,
        modifiedCallback,
        true,
      ),
    });
  }

  useEffect(() => {
    if (!showHighlights) {
      return;
    }
    const stableCallback = (newCoordinates: HighlightObjectModified) => {
      coordinatesModifiedRef.current(newCoordinates);
    };

    dispatchHighlight(
      "add",
      locationHighlightKey,
      HighlightColours.getHighlightColor(index),
      matcher.section,
      stableCallback,
    );
    return () => {
      dispatchHighlight(
        "remove",
        locationHighlightKey,
        HighlightColours.getHighlightColor(index),
        matcher.section,
        (x: any) => null,
      );
    };
  }, [
    showHighlights,
    locationHighlightKey,
    index,
    matcher.section,
    highlightDispatch,
  ]);
}
